<template>
  <div id="ctrl_view">
    <div id="ctrls">
      <div class="ctrl_btn activ_btn" @click="switcSounds">
        <img :src="sounds_icon_src">
      </div>
      <div class="ctrl_btn activ_btn" @click="switchBGM">
        <img :src="bgm_icon_src">
      </div>
      <div class="ctrl_btn" :class="{ activ_btn: isActive }" @click="showHowTo">
        <img :src="howTo_icon_src">
      </div>
      <div class="ctrl_btn activ_btn" @click="contactUS">
        <img :src="contact_icon_src">
      </div>
    </div>

    <!-- 遊び方 -->
    <vodal measure="px" :show="howto_view_show" :animation="animation" :width="300" :height="470" :duration="301" class="my-dialog" @hide="howto_view_show = false">
      <div class="vodal_view">
        <div class="vodal_header">
          <font-awesome-icon icon="flag" />
          <p>遊び方</p>
        </div>
        <div class="vodal_content_howto" :style="styleItem">
          <HowToPlay />
        </div>
        <div class="vodal_footer">
          <div @click="howto_view_show = false">OK</div>
        </div>
      </div>
    </vodal>

    <!-- サウンドアラート -->
    <vodal measure="px" :show="sounds_alert_show" :animation="animation" :width="300" :height="260" :duration="300" class="my-dialog" @hide="sounds_alert_show = false">
      <div class="vodal_view">
        <div class="vodal_header">
          <font-awesome-icon icon="music" />
          <p>Attention!</p>
        </div>
        <div class="vodal_content">
          BGM・効果音が再生されます。
          <br>よろしいですか？
        </div>
        <div class="vodal_footer">
          <div @click="soundsMuteOn">Cancel</div>
          <div @click="soundsMuteOff">OK</div>
        </div>
      </div>
    </vodal>

    <!-- お問い合わせ -->
    <vodal measure="px" :show="contact_view_show" :animation="animation" :width="300" :height="260" :duration="300" class="my-dialog" @hide="contact_view_show = false">
      <div class="vodal_view">
        <div class="vodal_header">
          <font-awesome-icon icon="envelope" />
          <p>お問い合わせ</p>
        </div>
        <div class="vodal_content">
          <p style="font-size: 16px">
            トランプ、アプリに関する
            <br>お問い合わせは
            <br>
            <a href="https://www.tcgmap.jp/contact/" target="_blank">こちら</a>からお願いいたします。
          </p>
          <p style="font-size: 12px">
            ※オンラインショップに関する
            <br>お問い合わせをご利用ください。
          </p>
        </div>
        <div class="vodal_footer">
          <div class="vodal_footer">
            <div @click="contact_view_show = false">Cancel</div>
          </div>
        </div>
      </div>
    </vodal>
  </div>
</template>

<script>
import Vodal from "vodal"
import HowToPlay from "../components/HowToPlay.vue"

/**
 * コントロール部（各種ボタン）
 * 
 * @vue-data {Boolean} [contact_view_show=false] お問い合わせポップアップの表示フラグ
 * @vue-data {Boolean} [howto_view_show=false] 遊び方ポップアップの表示フラグ
 * @vue-data {Boolean} [sounds_alert_show=false] 音が出ますポップアップの表示フラグ
 * @vue-data {String} [animation='slideDown'] ポップアップのアニメーションタイプ（flip)
 * @vue-data {Object} [bgm_icon_src=null] BGMボタンイメージソース
 * @vue-data {Object} [sounds_icon_src=null] 効果音ボタンイメージソース
 * @vue-data {Object} [howTo_icon_src=null] 遊び方ボタンイメージソース
 * @vue-data {Object} [contact_icon] お問い合わせボタンイメージソース（黒クラブ）
 * @vue-data {Object} [bgm_icon] BGMボタンイメージ（赤ハート）
 * @vue-data {Object} [bgm_icon_gray] BGMボタンイメージ（灰ハート）
 * @vue-data {Object} [sounds_icon] 効果音ボタンイメージ（黒スペード）
 * @vue-data {Object} [sounds_icon_gray] 効果音ボタンイメージ（灰スペード）
 * @vue-data {Object} [howTo_icon] 遊び方ボタンイメージ（赤ダイヤ）
 * @vue-data {Object} [howTo_icon_gray] 遊び方ボタンイメージ（灰ダイヤ）
 * @vue-data {Object} [styleItem=null] 遊び方ポップアップのスタイル
 * @vue-data {Object} [styleItemW] 遊び方ポップアップのスタイルオブジェクト（世界）
 * @vue-data {Object} [styleItemJ] 遊び方ポップアップのスタイルオブジェクト（日本）
 * @vue-data {Boolean} [isActive=false] 各ボタンのアクティブフラグ
 * @vue-computed {Boolean} soundsMute 効果音のミュートフラグ（true, false）
 * @vue-computed {Boolean} bgmMute BGMのミュートフラグ（true, false）
 * @vue-computed {String} currentGame 表示中のルーレット名
 * @vue-computed {Boolean} firstProc 初回起動フラグ（true, false）
 */
import soundMixin from '../libs/soundMixin.js'
export default {
  name: "ControlView",

  components: {
    Vodal,
    HowToPlay
  },

  mixins: [
    soundMixin
  ],

  data () {
    return {
      contact_view_show: false,
      howto_view_show: false,
      sounds_alert_show: false,
      animation: "slideDown",
      bgm_icon_src: null,
      sounds_icon_src: null,
      howTo_icon_src: null,
      contact_icon_src: require("../assets/footer_icons/contact.png"),
      bgm_icon: require("../assets/footer_icons/bgm.png"),
      bgm_icon_gray: require("../assets/footer_icons/bgm_gray.png"),
      sounds_icon: require("../assets/footer_icons/sounds.png"),
      sounds_icon_gray: require("../assets/footer_icons/sounds_gray.png"),
      howTo_icon: require("../assets/footer_icons/how_to_play.png"),
      howTo_icon_gray: require("../assets/footer_icons/how_to_play_gray.png"),
      styleItem: null,
      styleItemW: {
        backgroundImage:
          "url(" + require("../assets/howto/how_to_play_bk_w.png") + ")",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      },
      styleItemJ: {
        backgroundImage:
          "url(" + require("../assets/howto/how_to_play_bk_j.png") + ")",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      },
      isActive: false
    }
  },

  computed: {
    soundsMute () {
      return this.$store.getters.soundsMute
    },
    bgmMute () {
      return this.$store.getters.bgmMute
    },
    currentGame () {
      return this.$store.getters.currentGame
    },
    firstProc () {
      return this.$store.getters.firstProc
    },
    snd () {
      return this.$store.getters.snd
    }
  },

  mounted () {
    this.bgm_icon_src = this.bgm_icon_gray
    this.sounds_icon_src = this.sounds_icon_gray
    this.howTo_icon_src = this.howTo_icon
  },

  watch: {
    currentGame () {
      if (this.currentGame.match(/^World/i)) {
        this.styleItem = this.styleItemW
      } else if (this.currentGame.match(/^Japan/i)) {
        this.styleItem = this.styleItemJ
      } else {
        this.styleItem = null
      }

      if (this.currentGame.match(/Normal|Hard/i)) {
        this.howTo_icon_src = this.howTo_icon
        this.isActive = true
      } else {
        this.howTo_icon_src = this.howTo_icon_gray
        this.isActive = false
      }
    }
  },

  methods: {
    /**
     * 遊び方ポップアップの表示
     */
    showHowTo () {
      if (this.currentGame.match(/^(Home|World|Japan)$/i)) {
        return
      }
      this.playPopupSound()
      this.animation = "flip"
      this.howto_view_show = true
    },

    /**
     * BGMのOnOff切り替え（初回のみポップアップを表示）
     */
    switchBGM () {
      if (this.firstProc) {
        this.sounds_alert_show = true
        this.$store.dispatch("setFirstProc", { setFirstProc: false })
        return
      }
      if (this.bgmMute) {
        // console.log('bgmMute: ' + this.bgmMute)
        this.playBGM()
      } else {
        this.muteBGM()
      }
    },

    /**
     * BGM再生
     */
    playBGM () {
      // console.log('playBGM')
      this.playBgmSound()
      // BGM off
      this.bgm_icon_src = this.bgm_icon
      this.$store.dispatch("setBGM", { bgmMute: false })
    },

    /**
     * BGM停止
     */
    muteBGM () {
      // console.log('muteBGM')
      this.stopBgmSound()
      // BGM on
      this.bgm_icon_src = this.bgm_icon_gray
      this.$store.dispatch("setBGM", { bgmMute: true })
      this.sounds_alert_show = false
    },

    /**
     * 効果音のOnOff切り替え（初回のみポップアップを表示）
     */
    switcSounds () {
      if (this.firstProc) {
        this.sounds_alert_show = true
        this.$store.dispatch("setFirstProc", { setFirstProc: false })
        return
      }
      if (this.soundsMute) {
        this.playSounds()
      } else {
        this.muteSounds()
      }
    },

    /**
     * 効果音Muteフラグをfalseに
     */
    playSounds () {
      // Sounds off
      this.sounds_icon_src = this.sounds_icon
      this.$store.dispatch("setSounds", { soundsMute: false })
      this.playRouletteSound()
    },

    /**
     * 効果音Muteフラグをtrueに
     */
    muteSounds () {
      this.stopRouletteSound()
      // 'Sounds on'
      this.sounds_icon_src = this.sounds_icon_gray
      this.$store.dispatch("setSounds", { soundsMute: true })
    },

    /**
     * お問い合わせポップアップの表示
     */
    contactUS () {
      this.playPopupSound()
      this.contact_view_show = true
    },

    /**
     * 音が出ますポップアップのCancelボタンイベント
     */
    soundsMuteOn () {
      this.muteBGM()
      this.muteSounds()
      this.sounds_alert_show = false
    },

    /**
     * 音が出ますポップアップのOKボタンイベント
     */
    soundsMuteOff () {
      this.playSounds()
      this.playBGM()
      this.sounds_alert_show = false
    }
  }
}
</script>

<style lang="sass" src='../assets/common_style.sass'></style>
<style lang="sass" scoped>

#ctrl_view
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  color: #29292A
  min-height: 140px
  position: relative

#ctrls
  display: flex
  flex-direction: row
  justify-content: center
  align-items: center
  // flex-wrap: wrap
  min-height: 60px
  padding: 10px

.ctrl_btn 
  max-width: 120px
  font-size: 12px
  img
    width: 100%

.vodal_content
  flex-direction: column
  a
    color: #DC5310
</style>
